export default __webpack_public_path__ + "static/dashboard.es-e90cc60cb260c797887d1f36a08b8b94.svg";